import { ChannelTypes } from 'conversations-internal-schema/constants/ChannelTypes';
import { BOT } from 'routing-ui/routing-rules/constants/RoutingTypes';
export const CHANNEL_MIGRATION_STATES = {
  COMPLETE: 'COMPLETE',
  FAILED: 'FAILED',
  NOT_STARTED: 'NOT_STARTED',
  SCHEDULED: 'SCHEDULED',
  STARTED: 'STARTED',
  STARTING: 'STARTING'
};
export const MIGRATABLE_CHANNEL_TYPES = [BOT, ChannelTypes.CHAT, ChannelTypes.EMAIL, ChannelTypes.FORMS];
export const MIGRATABLE_CHANNEL_IDS = {
  LIVE_CHAT: 1000,
  EMAIL: 1002,
  FORMS: 1003
};